import Immutable from "immutable";

export function createKeyStore() {
	let store = Immutable.Set();
	return {
		add: key => { store = store.add(key) },
		remove: key => { store = store.remove(key) },
		contains: key => store.contains(key),
		get size() { return store.size },
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/focusPlugin/createKeyStore.js